import { render } from "./ProductSearchImage.vue?vue&type=template&id=e6b25868&scoped=true"
import script from "./ProductSearchImage.vue?vue&type=script&lang=js"
export * from "./ProductSearchImage.vue?vue&type=script&lang=js"

import "./ProductSearchImage.vue?vue&type=style&index=0&id=e6b25868&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6b25868"]])

export default __exports__